import React from 'react';
import { Flex, Heading } from 'rebass';
import { useSelector } from 'react-redux';
import { getPendingCandidate } from 'selectors/candidates';
import Frame from 'components/Frame';
import ReviewPendingCandidateForm from 'modules/Candidates/components/ReviewPendingCandidateForm';

const ReviewPendingCandidate: React.FC<any> = ({ match }): JSX.Element => {
  const candidate = useSelector<any, any>((state: any) =>
    getPendingCandidate(state, +match.params.id)
  );

  return (
    <>
      <Flex>
        <Frame>
          <Flex width="100%" flexDirection="column">
            <Flex width="100%" flexDirection="column" pt={7} pb={1}>
              <Heading as="h2" fontSize="36px" fontWeight={6} mb={6}>
                Review a Candidate
              </Heading>
              <Heading as="h2" fontSize="36px" fontWeight={6}>
                {candidate.companyName}
              </Heading>
            </Flex>
            <ReviewPendingCandidateForm candidate={candidate} />
          </Flex>
        </Frame>
      </Flex>
    </>
  );
};

export default ReviewPendingCandidate;
